export function generateUniqueKey(prefix: string, index: number, index2?: number): string {
    const key = `${prefix}-${index}`;
    if (index2) {
        return `${key}-${index2}`;
    }
    return key;
}
export function getChildElements(element: Element): Element[] {
    return Array.from(element?.children ?? []);
}

export function getChildByTagName(element: Element, tagName: string): Element | null {
    return getChildElements(element).find(child => child.tagName === tagName) ?? null;
}
